export default "__VITE_ASSET__CBKC6NtY__"